import React from 'react';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import {
  DPI_APP_CRASHES_V2_DIMENSIONS,
  appCrashV2Metrics,
} from '@utils/dimension/appDimensionHelper';
import { allDimensionsListSelector } from '@src/store/common/dimensionList/selectors';
import StaticTableWidget from './StaticTable';

function AppCrashV2Widget() {
  const selectedMetric = useSelector(selectedMetricSelector);
  if (!appCrashV2Metrics.includes(selectedMetric)) {
    return null;
  }
  return (
    <>
      {DPI_APP_CRASHES_V2_DIMENSIONS.map((options) => {
        return (
          <DimensionTableWidget
            header={options.header}
            dimension={options.dimension}
            key={options.dimension}
          />
        );
      })}
    </>
  );
}

const DimensionTableWidget: React.FC<{ header: string; dimension: string }> = (props) => {
  const { header, dimension } = props;

  const supportedDimension = useSelector(allDimensionsListSelector) as any[];
  // disable drill down if this dimension is not in supported dimension list
  const disableDrilldown = supportedDimension.every((it) => it.groupBy !== dimension);

  return (
    <StaticTableWidget header={header} dimension={dimension} disableDrilldown={disableDrilldown} />
  );
};

export default AppCrashV2Widget;
